import i18n from "@/i18n/config";
import { toast } from "@/utils/toast";
import { FC, useEffect, useRef } from "react";
import { Id } from "react-toastify";

export const InternetStatus: FC = () => {
  const toastId = useRef<Id>();

  useEffect(() => {
    const handleOnline = () => {
      toastId.current && toast.close(toastId.current);
      toastId.current = toast.success(i18n.t("common.internetRestored"));
    };

    const handleOffline = () => {
      toastId.current && toast.close(toastId.current);
      toastId.current = toast.error(i18n.t("common.internetLost"));
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return null;
};
